import cake1 from '../imgs/cake1.jpg';
import cake2 from '../imgs/cake2.jpg';
import cake3 from '../imgs/cake3.jpg';
import cake4 from '../imgs/cake4.jpg';
import cake5 from '../imgs/cake5.jpg';
import cake6 from '../imgs/cake6.jpg';
import '../data/menu.css';

export const cakes = [
	{
		img: cake1,
		alt: 'Cake',
		title: 'Strawberry mix',
		desc: 'A bloom of summer strawberries and cream adorned plate.',
		price: '$29.90',
		button: 'Select',
	},
	{
		img: cake2,
		alt: 'Cake',
		title: 'Forest',
		desc: 'Chocolate chiffon with Chantilly, and frosting, garnished with macadamia nuts.',
		price: '$32.90',
		button: 'Select',
	},
	{
		img: cake3,
		alt: 'Cake',
		title: 'French dessert',
		desc: 'Chocolate crème cake with cherries, whip cream frosting and chocolate crumbles.',
		price: '$29.90',
		button: 'Select',
	},
	{
		img: cake4,
		alt: 'Cake',
		title: 'Coffee cake',
		desc:
			'The yam cake with its sweet glaze was quite the perfect accompaniment to the coffee.',
		price: '$29.90',
		button: 'Select',
	},
	{
		img: cake5,
		alt: 'Cake',
		title: 'Brownie Cake',
		desc: 'Perfectly sized cake with a lots and lots of chocolate, nuts and creme',
		price: '$39.90',
		button: 'Select',
	},
	{
		img: cake6,
		alt: 'Cake',
		title: 'Chocolate mood',
		desc: 'The most favorite birthday cake for kids, with chocolate creme and chips.',
		price: '$19.90',
		button: 'Select',
	},
];


